// extracted by mini-css-extract-plugin
module.exports = {"selectableTable":"AdAccountSelection-module__selectableTable___1CYxt","table":"AdAccountSelection-module__table___2te2n"};